<template>
    <div class="page-notification" :class="type" :data-ci="dataCi">
        <div class="page-notification__icon">
            <i8-icon :icon="icon" />
        </div>

        <div class="page-notification__message">
            <span>
                <strong>{{ name }}</strong>
            </span>
            <ul>
                <li
                    v-for="(message, index) in messages"
                    v-bind:key="`msg--${index}`"
                >
                    {{ message }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import I8Icon from '@shared/components/I8Icon';

const name = 'page-notification';

export default {
    name,
    componentName: name,
    components: {
        [I8Icon.name]: I8Icon,
    },
    props: {
        messages: { type: Array, default: [''] },
        type: { type: String, default: 'info' },
        name: { type: String, default: '' },
        dataCi: { type: String, default: '' },
    },
    computed: {
        icon() {
            switch (this.type) {
                case 'error':
                    return 'circle-error-solid';
                case 'info':
                    return 'circle-fill-information';
                case 'warning':
                    return 'circle-error-solid';
                case 'blank':
                    return '';
                default:
                    return '';
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// shared/components/PageNotification.vue